var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lrf-tabs"},[_c('div',{staticClass:"tabs"},_vm._l((_vm.list),function(item){return _c('div',{key:item.componentName,staticClass:"tabs_item",class:{ active_item: _vm.activeName == item.componentName },on:{"click":function($event){_vm.activeName = item.componentName}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }